module.exports = "/static-assets/_next/static/images/sun-dfceb669d464b9d471b00f3851797fd7.svg";